import parse from 'html-react-parser';
export const truncateText = (text, characters = 150) =>
  text ? parse(text.substring(0, characters) + (text.length < characters ? '' : '...')) : ''
